<template>
  <div class="brief-presupuestos-internos-abm">
    <b-card class="brief-header">
      <div slot="header">
        Presupuestos Internos
        <i class="fa fa-plus"
          v-if="showPresupuestosInternos"
          id="add-presupuesto-interno"
          @click.prevent="addPresupuestoInterno">
        </i>        
      </div>
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showPresupuestosInternos= !showPresupuestosInternos">
        <i :class="showPresupuestosInternos ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="headerPresupuestosInternos" class="mt-2" v-model="showPresupuestosInternos">
        <b-row>
          <b-col>
            <b-table 
                :key="key"
                hover
                responsive="sm" 
                class="registro"
                :items="presupuestosInternos" 
                :fields="presupuestosInternosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(opciones)="data">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item
                      @click.stop="deleteItem(data.item)">
                    <i class="fa fa-remove"></i>Borrar Presupuesto Interno</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'BriefPresupuestosInternosABM',
  props: {
    presupuestosInternos: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      key: 0,

      presupuestosInternosFields: [
        {
          key: 'presupuestoNumero',
          label: 'Nro.Presupuesto',
        },
        {
          key: 'accion',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center',
        }
      ],

      showPresupuestosInternos: false,

      labelCols: 2,
    }
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    refresh() {
      this.key++;
    },
    addPresupuestoInterno() {
      this.$emit('addPresupuestoInterno');
    },
    deleteItem(item) {
      this.$emit('deletePresupuestoInterno', item.presupuestoInternoId);
    }
  }
}
</script>

<style>
  .brief-presupuestos-internos-abm #add-presupuesto-interno {
    position: relative;
    margin-left: 10px;
    cursor: pointer;
    color: #20a8d8;
  }
  .brief-presupuestos-internos-abm #add-presupuesto-interno:hover {
    color: #1b8eb7;
  }

  .brief-presupuestos-internos-abm table thead th {
    border-top: none;
  }
  .brief-presupuestos-internos-abm table td[aria-colindex="1"] {
    width: 20%;
  }
  .brief-presupuestos-internos-abm table td[aria-colindex="2"] {
    width: calc(80% - 60px);
  }
  .brief-presupuestos-internos-abm table td[aria-colindex="3"] {
    width: 60px;
  }
</style>